
import Vue from "vue";
import msDataProvider from "../services/msDataProvider";
export default Vue.extend({
  data() {
    return {
      processing: false,
    };
  },
  async created() {
    const accessToken = this.$route.query && this.$route.query.access_token;
    if (accessToken) {
      this.processing = true;
      await msDataProvider.executeCommand("authenSetAccessToken", accessToken);
      location.href = location.origin + location.pathname;
    }
  },
});
